<template>
  <div>
    <!-- 标题 -->
    <mtd-row style="margin-top:37px;">
      <mtd-col :span="24">
        <span class="dd-page-title">{{ $getText('wenshu_web_file_export', '文件外发') }}</span>
      </mtd-col>
    </mtd-row>
    <!-- 图标展示 -->
    <mtd-row style="margin-top:64px;">
      <!-- 审批中状态 -->
      <mtd-col :span="24" v-if="bpmStatus === 0" style="text-align: center;">
        <i class='mtdicon-time' style="color: #0A70F5;font-size: 56px;"></i>
        <div class="bpm-status-title">{{ checkingResult }}</div>
        <div style="height: 72px"></div>
      </mtd-col>
      <!-- 审批通过状态 -->
      <mtd-col :span="24" v-if="bpmStatus === 1" style="text-align: center;">
        <i class='mtdicon-success-circle' style="color: #00b365;font-size: 56px;"></i>
        <div class="bpm-status-title" v-if="emailFlag">{{ passAndEmailResult }}</div>
        <div class="bpm-status-title" v-else="emailFlag">{{ passResult }}</div>
        <div style="height: 72px"></div>
      </mtd-col>
      <!-- 审批未通过状态 -->
      <mtd-col :span="24" v-if="bpmStatus && bpmStatus !== 0 && bpmStatus !== 1" style="text-align: center;">
        <i class='mtdicon-error-o' style="color: #FF5F57;font-size: 56px;"></i>
        <div class="bpm-status-title">{{ noPassResult }}</div>
        <div style="height: 72px"></div>
      </mtd-col>
    </mtd-row>
    <!-- 提示信息 -->
    <mtd-row>
      <mtd-col :span="24" style="text-align: center;">
        <div style="width: 60%;display: inline-block">
          <mtd-announcement :title="$getText('wenshu_web_module_forward_record_sync_to_supervisor_non_work_purpose_forward_will_face_penalty', '外发记录已同步至您的上级，非工作目的外发，将会面临处罚')"
                            type="warning" show-icon/>
        </div>
      </mtd-col>
    </mtd-row>
    <!-- 外发信息 -->
    <mtd-row style="margin-top: 12px">
      <mtd-col :span="24" style="text-align: center;">
        <div style="width: 60%;display: inline-block">
          <mtd-row justify="center" type="flex">
            <div class="file-out-result-title-complete">
              <span>{{ $getText('wenshu_web_module_forward_information', '外发信息') }}</span>
              <span style="color: #FF5F57;float: right">
                <span v-if="bpmStatus !== 1">
                  {{ $getText('wenshu_web_module_after_approval_success_link_can_be_accessed', '审批成功后，该链接才能被访问') }}
                </span>
                <span v-if="bpmStatus === 1">
                  <i class='mtdicon-time' style="margin-right: 4px;"/>
                  {{ $getText('ws_mobile_link_created_expire_tips', {createDate: dateTimeFormat(applyCreateTime * 1000), expireHours: dateTimeFormat(applyExpireHours * 1000)}, '链接于{createDate}创建，{expireHours}后过期') }}
                </span>
              </span>
            </div>
          </mtd-row>
          <mtd-row justify="center" type="flex">
            <div class="file-out-result-content-complete">
              <div class="complete-content-tips">
                <span class="tips">
                  {{ $getText('wenshu_web_module_copy_share_link_and_extraction_password_send_to_relevant_personnel', '1.复制分享链接和提取密码，发送给相关人员') }}
                  <mtd-button class="tips-button" type="text" icon="mtdicon mtdicon-copy-o" @click="copyUrl()"
                              v-clipboard:copy="copyMessage" v-clipboard:success="copySuccess"
                              v-clipboard:error="copyError">{{ $getText('wenshu_web_module_copy', '复制') }}
                </mtd-button>
                </span>
              </div>
              <mtd-form style="margin-top: 12px;">
                <mtd-form-item class="shared-link-wrapper"  :label="$getText('wenshu_web_file_share_link', '文件分享链接') + ':'" style="margin-bottom: 8px;min-height: 22px">
                  <span class="shared-link">{{ fileOutUrl }}</span>
                </mtd-form-item>
                <mtd-form-item class="shared-link-wrapper" :label="$getText('wenshu_web_module_extraction_password', '提取密码:')" style="margin: 0px;height: 22px">
                  <span>{{ downloadPassword }}</span>
                </mtd-form-item>
              </mtd-form>
            </div>
          </mtd-row>
        </div>
      </mtd-col>
    </mtd-row>

    <div style="margin-top: 32px">
      <mtd-row justify="center" type="flex">
        <div>
          <mtd-button size="large" @click="back_to_file_out"
                      style="color: #0A70F5;border: 1px solid #0A70F5;">{{ $getText('wenshu_web_module_continue_forward', '继续外发') }}
          </mtd-button>
        </div>
      </mtd-row>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import moment from "moment";

export default {
  name: "file_out_completed",
  data() {
    return {
      pass: false,
      successTips: this.$getText('wenshu_web_sharing_remind', '（备注：外发记录已同步至您的上级）'),
      outTips: '（' + this.$getText('wenshu_web_module_after_approval_success_link_can_be_accessed', '审批成功后，该链接才能被访问') + "）",
      fileOutUrl: '',
      bpmAddress: '',
      downloadPassword: '',
      checkingResult: this.$getText('ws_mobile_approval_initiated_tips', '已经发起审批，如果长时间未反馈，可大象联系审批人进入审批详情页催办'),
      passResult: this.$getText('wenshu_web_apply_approved_1', '审批通过'),
      noPassResult: this.$getText('wenshu_web_apply_not_approved', '审批未通过'),
      emailFlag: true,
      passAndEmailResult: this.$getText('wenshu_web_apply_approved_email', '审批通过,链接已发送至邮箱'),
      copyMessage: '',
      recordId: null,
      bpmStatus: null,
      approvalDetail: {
        list: [],
        currentNode: null,
      },
      bpmDetailData: null,
      approvalExpand: true,
      applyCreateTime: null,
      applyExpireHours: null,
    }
  },
  computed: {
    statusDefine() {
      return function (index) {
        if (index < this.approvalDetail.currentNode) {
          return 'finish';
        } else if (index === this.approvalDetail.currentNode) {
          if (this.approvalDetail.status === 1) {
            return 'finish';
          } else if (this.approvalDetail.status === 2 || this.approvalDetail.status === 6) {
            return 'error';
          } else if (this.approvalDetail.status === 3) {
            return 'process';
          }
        } else {
          return 'wait';
        }
      }
    },
  },
  mounted() {
    var shared = this.$route.params.shared;
    if (shared == null) {
      shared = {status: 0};
      console.log(shared);
      this.queryLastRecordInfo().then(res => {
        this.fileOutUrl = res.data.url;
        this.downloadPassword = res.data.password;
        this.bpmAddress = res.data.bpmDetails;
        this.recordId = res.data.recordId;
        this.bpmStatus = res.data.bpmStatus;
        this.applyCreateTime = res.data.createTimestamp;
        this.applyExpireHours = res.data.expireTimestamp;

        if (res.data.bpmStatus === 1) {
          this.pass = true;
        }
        if (res.data.fileOutEmails == null || res.data.fileOutEmails === '') {
          this.emailFlag = false;
        }
      });
    } else {
      this.fileOutUrl = shared.url;
      this.downloadPassword = shared.password;
      this.bpmAddress = shared.bpmDetails;
      this.recordId = shared.recordId;
      this.bpmStatus = shared.status;
      this.applyCreateTime = shared.createTimestamp;
      this.applyExpireHours = shared.expireTimestamp;
      if (shared.status === 1) {
        this.pass = true;
      }
      let emails = this.$route.params.emails;
      if (emails == null || emails === '') {
        this.emailFlag = false;
      }
    }
  },
  methods: {
    ...mapActions([
      'queryLastRecordInfo',
      'queryApprovalDetails'
    ]),
    api_select_process(id) {
      if (!id) {
        return;
      }
      this.queryApprovalDetails({id}).then(res => {
        console.log(res);
        if (res.code === 0) {
          if(res.approvalList){
            this.approvalDetail = res.approvalList;
          }
          this.bpmDetailData = res.data;
        }
      });
    },
    copyUrl() {
      let url = this.fileOutUrl;
      let pass = this.downloadPassword;
      let info = this.$getText('wenshu_web_module_file_share_link', '文件分享链接') + ` ${url} \n` + this.$getText('wenshu_web_module_extraction_password', '提取密码') + `${pass}`;
      this.copyMessage = info;
    },
    copySuccess() {
      this.$mtd.message({
        message: this.$getText('wenshu_web_module_link_copied', '链接已复制到剪切板'),
        type: 'success',
      });
    },
    copyError() {
      this.$mtd.message({
        message: this.$getText('wenshu_web_module_copy_failed', '复制失败'),
        type: 'error',
      });
    },
    back_to_file_out() {
      this.$router.push({path: "file_outer_upload"});
    },
    dateTimeFormat(dateTime) {
      return moment(dateTime)
        .utcOffset(480)
        .format('YYYY-MM-DD HH:mm:ss');
    },
  }
}
</script>

<style>

.dd-page-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0.5px;
  line-height: 32px;
  font-weight: 500;
}

.dd-page-subtitle {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 22px;
  font-weight: 500;
}

.page-info-detail {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.36);
  line-height: 20px;
  font-weight: 400;
  margin-left: 10px;
}

.margin-bottom-0 {
  margin-bottom: 0;
}

h2.dd-page-title {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 33px;
  margin-bottom: 32px;
}

.file-upload-progress {
  height: 48px;
  border: 1px solid rgba(0, 0, 0, 0.24);
  border-radius: 4px;
}

.mtd-progress .mtd-progress-bar .mtd-progress-bar-outer .mtd-progress-bar-inner {
  border-radius: 4px;
}

.mtd-progress .mtd-progress-bar .mtd-progress-bar-outer {
  border-radius: 4px;
}

.mtd-progress .mtd-progress-bar {
  padding: 0;
}

.mtd-progress .mtd-progress-percentage {
  display: none;
}

.file-out-result-title-complete {
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 4px 4px 0 0;
  width: 100%;
  font-weight: 500;
  background: #F7F7F7;
  padding: 6px 16px;
  text-align: left;
}

.file-out-result-content-complete {
  border-radius: 0 0 4px 4px;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-top: none;
  width: 100%;
  padding: 16px;
}

.shared-link-wrapper > .mtd-form-item-label {
  line-height: 22px;
}

.mtd-form-item-content {
  line-height: 22px;
}

.shared-link {
  word-wrap: break-word;
}

.approval-progress {
  background-color: white;
  padding: 16px 24px;
  border-radius: 10px;
}

.div-title {
  font-family: PingFang SC, sans-serif;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  line-height: 21px;
  text-align: left;
}

.div-icon {
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  line-height: 22px;
  font-weight: 400;
}

.progress-success-tips {
  font-family: PingFang SC, sans-serif;
  font-size: 13px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  font-weight: 500;
  line-height: 18px
}

.demo-timeline-success {
  color: #5ABB3C;
  font-size: 20px;
  vertical-align: middle;
}

.demo-timeline-error {
  color: #FF6459;
  font-size: 20px;
  vertical-align: middle;
}

.demo-timeline-primary {
  color: #4E73FF;
  font-size: 20px;
  vertical-align: middle;
}

.approval-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  line-height: 21px;
  margin-bottom: 8px;
}

.approval-img {
  vertical-align: middle;
  width: 24px;
  height: 24px;
  border-radius: 100%;
}

.mtd-timeline-item-content-wrapper, .mtd-timeline-item-title {
  padding-bottom: 0px;
}

.mtd-step-finish .mtd-step-head-number {
  color: #00B365;
  border: 1px solid #00B365;
}

.mtd-steps-small.mtd-steps-vertical .mtd-step-main {
  top: -3px;
}

.br-div {
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.bpm-status-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.84);
  text-align: center;
  line-height: 26px;
  font-weight: 500;
}

.complete-content-tips {
  height: 24px;
}

.complete-content-tips .tips {
  float: left;
  text-align: left;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.84);
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
}

.complete-content-tips .tips-button {
  padding: 0;
  height: 24px;
  text-align: right;
  cursor: pointer;
}

.complete-content-tips .tips-button span {
  line-height: 24px;
}
</style>
